import styled, { css } from 'styled-components';
import { Row } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';
import { OneColumn } from '@components/Layout';

export const BackgroundContainer = styled('section')`
  background-color: white;
  width: 100%;
  color: ${({ theme }) => theme.color.spaceGray};
`;

export const OneColumnExpanded = styled(OneColumn)`
  max-width: 1260px;
  padding-bottom: ${({ theme }) => theme.x5spacePx}px;
  ${media.mdDown`
      padding-bottom: 0;
    `}
`;

export const HeaderContainer = styled('nav')`
  padding: ${({ theme }) =>
    `${theme.x2spacePx}px ${theme.x2spacePx}px ${theme.x1spacePx}px  ${theme.x2spacePx}px`};
`;

export const HeroContainerRow = styled(Row)`
  background-color: transparent;
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 400px;
  ${media.mdUp`
    height: 830px
  `}
  ${media.mdOnly`
    height: 560px
  `}
`;

export const Image = styled('img')`
  position: absolute;
  width: 100%;
  top: 180px;
  transform: scale(2.9);
  object-fit: cover;
  ${media.mdUp`
    top: 0;
    left: 0;
    transform: none;
    height: 100%;
  `}

  @media screen and (max-width: 310px) {
    top: 200px;
    left: 50px;
    transform: scale(3.6);
  }
`;

export const sectionHeading = css`
  font-size: 28px;
  line-height: 42px;
  letter-spacing: -0.02em;
  font-weight: 700;
  color: ${({ theme }) => theme.color.spaceGray};
  ${media.lgUp`
    line-height: 60px;
    ${({ theme }) => theme.typography.massStrong};
    font-weight: 700;
  `}
`;
